<header class="modal__header">
  <h2 class="modal__title" matDialogTitle>{{title | translate}}</h2>
  <button mat-icon-button color="primary" class="modal__close" title="{{'APP.GENERAL.CLOSE' | translate}}"  (click)="ok()" mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</header>

<section class="modal__content">
  <p *ngIf="!isInfoModalData()"> {{message | translate}} </p>
  <p *ngIf="isInfoModalData()"> {{message | translate:translateParams}} </p>

  <ul *ngIf="validationErrors" class="validationErrors">
    <li *ngFor="let err of validationErrors">{{err.message}}</li>
  </ul>

  <p class="validation-info" *ngIf="validationErrors">{{ 'APP.GENERAL.VALIDATION_INFO' | translate }}</p>

</section>



<div class="modal__footer">
  <button type="button" class="button button--primary" (click)="ok()">
      <span>{{ 'APP.GENERAL.OK' | translate }}</span>
  </button>
</div>
